import * as logger from 'universal-logger';
import { all, call, put, spawn, takeLatest } from 'redux-saga/effects';
import { ec } from 'helpers/multitrack';
import { segment } from 'helpers/segment';
import { searchFilterActions } from './filters/filters.helpers';
import { EVENTS, FILTER_NAMES, RESULT_TYPES } from './Search.constants';

export const ACTION_TYPES = {
  [RESULT_TYPES.SCHEDULE]: 'select_classes',
  [RESULT_TYPES.VENUE]: 'select_studios',
};
export const RESULT_TYPE_CLICKED = 'classpass/search/RESULT_TYPE_CLICKED';
export const resultTypeClicked = resultType => ({ type: RESULT_TYPE_CLICKED, resultType });

export function* onResultTypeClicked({ resultType }) {
  try {
    const action = ACTION_TYPES[resultType];

    yield all([
      put(searchFilterActions.setFilterValue(FILTER_NAMES.RESULT_TYPE, resultType)),
      call(segment.track, EVENTS.changeView, { action }),
      spawn(ec, EVENTS.changeView, { action }),
    ]);
  } catch (err) {
    yield call(logger.error, 'Search - Could not set tab', err);
  }
}

export function* watchResultType() {
  yield takeLatest(RESULT_TYPE_CLICKED, onResultTypeClicked);
}
